import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class FormCommand extends AbstractConfDataCommand
{
  formDecorationId: number;
  formControlId: number;
}